var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "row" }, [
    _c("div", { staticClass: "col-md-2" }, [
      _c("div", { staticClass: "service-detail__container" }, [
        _c("span", { staticClass: "service-title" }, [
          _vm._v("Tipo de Servicio:")
        ]),
        _c("p", { staticClass: "service-info" }, [
          _vm._v(" " + _vm._s(_vm.value.serviceTypeName) + " ")
        ])
      ]),
      _vm.canShowLocationType
        ? _c("div", { staticClass: "service-detail__container" }, [
            _c("span", { staticClass: "service-title" }, [
              _vm._v("Tipo de Lugar:")
            ]),
            _c("p", { staticClass: "service-info" }, [
              _vm._v(" " + _vm._s(_vm.value.locationTypeName) + " ")
            ])
          ])
        : _vm._e()
    ]),
    _c("div", { staticClass: "col-md-3" }, [
      _c("div", { staticClass: "service-detail__container" }, [
        _c("span", { staticClass: "service-title" }, [
          _vm._v("Servicio/Actividad:")
        ]),
        _vm.value.languageId === null
          ? _c("p", { staticClass: "service-info" }, [
              _vm._v(" " + _vm._s(_vm.value.disciplineTypeName) + " ")
            ])
          : _c("p", { staticClass: "service-info" }, [
              _vm._v(
                " " +
                  _vm._s(
                    _vm.value.disciplineTypeName +
                      " en idioma " +
                      _vm.value.languageName.toLowerCase()
                  ) +
                  " "
              )
            ])
      ]),
      _vm.canShowSchoolType
        ? _c("div", { staticClass: "service-detail__container" }, [
            _c("span", { staticClass: "service-title" }, [
              _vm._v("Tipo de Escuela:")
            ]),
            _c("p", { staticClass: "service-info" }, [
              _vm._v(" " + _vm._s(_vm.value.schoolTypeName) + " ")
            ])
          ])
        : _vm._e()
    ]),
    _c("div", { staticClass: "col-md-3" }, [
      _vm.canShowEvaluationType
        ? _c("div", { staticClass: "service-detail__container" }, [
            _c("span", { staticClass: "service-title" }, [
              _vm._v("Tipo de Evaluación:")
            ]),
            _c("p", { staticClass: "service-info" }, [
              _vm._v(" " + _vm._s(_vm.value.evaluationTypeName) + " ")
            ])
          ])
        : _vm._e(),
      _vm.canShowModality
        ? _c("div", { staticClass: "service-detail__container" }, [
            _c("span", { staticClass: "service-title" }, [
              _vm._v("Modalidad:")
            ]),
            _c("p", { staticClass: "service-info" }, [
              _vm._v(" " + _vm._s(_vm.value.serviceModalityTypeName) + " ")
            ])
          ])
        : _vm._e(),
      _vm.canShowMunicipality
        ? _c("div", { staticClass: "service-detail__container" }, [
            _c("span", { staticClass: "service-title" }, [
              _vm._v("Municipio:")
            ]),
            _c("p", { staticClass: "service-info" }, [
              _vm._v(" " + _vm._s(_vm.value.municipalityName) + " ")
            ])
          ])
        : _vm._e()
    ]),
    _c("div", { staticClass: "col-md-1" }, [
      _vm.canShowDuration
        ? _c("div", { staticClass: "service-detail__container" }, [
            _c("span", { staticClass: "service-title" }, [_vm._v("Duración:")]),
            _c("p", { staticClass: "service-info" }, [
              _vm._v(" " + _vm._s(_vm.value.therapyDurationName) + " ")
            ])
          ])
        : _vm._e(),
      _c("div", { staticClass: "service-detail__container" }, [
        _c("span", { staticClass: "service-title" }, [_vm._v("Costo:")]),
        _c("p", { staticClass: "service-info" }, [
          _vm._v(_vm._s(_vm._f("price")(_vm.value.amount)))
        ])
      ])
    ]),
    _c(
      "div",
      { staticClass: "col-md-2 d-flex justify-content-end align-items-center" },
      [
        _vm.canPerformActions
          ? _c("drop-down", {
              attrs: { "data-item": _vm.idx, items: _vm.availableActions }
            })
          : _vm._e(),
        (_vm.canPerformActions && _vm.hasSelection) ||
        (_vm.userHasPermissions("provider.contract.service.addupdate") &&
          this.hasSelection)
          ? _c(
              "div",
              { staticClass: "select-service-item__container" },
              [
                _c("CheckBox", {
                  staticClass: "select-service",
                  attrs: {
                    disabled:
                      _vm.disabled &&
                      !_vm.userHasPermissions(
                        "provider.contract.service.addupdate"
                      )
                  },
                  model: {
                    value: _vm.model.selected,
                    callback: function($$v) {
                      _vm.$set(_vm.model, "selected", $$v)
                    },
                    expression: "model.selected"
                  }
                })
              ],
              1
            )
          : _vm._e()
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }